var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3032_37583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59404 9.21309C2.62083 9.21309 2.64761 9.21041 2.6744 9.2064L4.92708 8.81131C4.95386 8.80595 4.97931 8.7939 4.99806 8.77381L10.6753 3.09657C10.6877 3.08418 10.6976 3.06947 10.7043 3.05326C10.711 3.03706 10.7145 3.01969 10.7145 3.00215C10.7145 2.98461 10.711 2.96725 10.7043 2.95104C10.6976 2.93484 10.6877 2.92012 10.6753 2.90773L8.4494 0.680502C8.42395 0.655055 8.39047 0.641663 8.35431 0.641663C8.31815 0.641663 8.28467 0.655055 8.25922 0.680502L2.58199 6.35773C2.5619 6.37782 2.54984 6.40193 2.54449 6.42872L2.1494 8.6814C2.13637 8.75314 2.14102 8.82698 2.16296 8.89653C2.1849 8.96607 2.22345 9.02922 2.27529 9.0805C2.36368 9.16622 2.47484 9.21309 2.59404 9.21309ZM3.49672 6.87738L8.35431 2.02113L9.336 3.00282L4.47841 7.85907L3.28779 8.06934L3.49672 6.87738ZM10.9284 10.3381H1.07127C0.834218 10.3381 0.6427 10.5296 0.6427 10.7667V11.2488C0.6427 11.3077 0.690914 11.3559 0.749843 11.3559H11.2498C11.3088 11.3559 11.357 11.3077 11.357 11.2488V10.7667C11.357 10.5296 11.1655 10.3381 10.9284 10.3381Z",
    fill: "current",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3032_37583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.63df887424231cefea0d618a74cb4bce.svg";
export { ForwardRef as ReactComponent };